"use strict";
import e from "./index.es144.js";
import f from "./index.es155.js";
import l from "./index.es265.js";
import c from "./index.es154.js";
import u from "./index.es266.js";
import m from "./index.es267.js";
import h from "./index.es149.js";
function S(r, i, n) {
  if (e.isString(r))
    try {
      return (i || JSON.parse)(r), e.trim(r);
    } catch (t) {
      if (t.name !== "SyntaxError")
        throw t;
    }
  return (n || JSON.stringify)(r);
}
const p = {
  transitional: l,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(r, i) {
    const n = i.getContentType() || "", t = n.indexOf("application/json") > -1, s = e.isObject(r);
    if (s && e.isHTMLForm(r) && (r = new FormData(r)), e.isFormData(r))
      return t ? JSON.stringify(h(r)) : r;
    if (e.isArrayBuffer(r) || e.isBuffer(r) || e.isStream(r) || e.isFile(r) || e.isBlob(r) || e.isReadableStream(r))
      return r;
    if (e.isArrayBufferView(r))
      return r.buffer;
    if (e.isURLSearchParams(r))
      return i.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), r.toString();
    let o;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return u(r, this.formSerializer).toString();
      if ((o = e.isFileList(r)) || n.indexOf("multipart/form-data") > -1) {
        const a = this.env && this.env.FormData;
        return c(
          o ? { "files[]": r } : r,
          a && new a(),
          this.formSerializer
        );
      }
    }
    return s || t ? (i.setContentType("application/json", !1), S(r)) : r;
  }],
  transformResponse: [function(r) {
    const i = this.transitional || p.transitional, n = i && i.forcedJSONParsing, t = this.responseType === "json";
    if (e.isResponse(r) || e.isReadableStream(r))
      return r;
    if (r && e.isString(r) && (n && !this.responseType || t)) {
      const s = !(i && i.silentJSONParsing) && t;
      try {
        return JSON.parse(r, this.parseReviver);
      } catch (o) {
        if (s)
          throw o.name === "SyntaxError" ? f.from(o, f.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return r;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: m.classes.FormData,
    Blob: m.classes.Blob
  },
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
e.forEach(["delete", "get", "head", "post", "put", "patch"], (r) => {
  p.headers[r] = {};
});
export {
  p as default
};
//# sourceMappingURL=index.es148.js.map
